import { Component } from '@angular/core';

/**
 * Superficie bloqueante a pantalla completa por papel vacío en la impresora de
 * pases de abordar (ATB Printer) — CI-23161.
 *
 * Es puramente declarativa: sin CTA, sin cierre manual y sin navegación. Se abre
 * y se retira exclusivamente desde `BoardingPassPaperService` en función de la
 * condición física del papel, de modo que el flujo que quede debajo permanece
 * intacto en memoria y vuelve a verse tal cual al recuperarse el papel.
 *
 * Reutiliza el shell visual fullscreen ya existente (`loading-full-colibri`)
 * sin alterar las variantes `network` / `emergency` del modal de conectividad.
 */
@Component({
  selector: 'app-boardingpass-paper-empty-modal',
  templateUrl: './boardingpass-paper-empty-modal.component.html',
  styleUrls: ['./boardingpass-paper-empty-modal.component.scss'],
  standalone: false,
})
export class BoardingPassPaperEmptyModalComponent {
  readonly titleKey = 'boardingPassPaper.emptyTitle';
  readonly messageKey = 'boardingPassPaper.emptyMessage';
  readonly instructionsKey = 'boardingPassPaper.emptyInstructions';
}
